/* eslint-disable camelcase */
export default {
	title: "Save your private thoughts and observations.",
	description: "<p>Use this space to jot down private notes for yourself, or to privately plan an agenda or conversation for the future.</p><p>Notes saved here will never be visible to anyone else (unless you share your screen).</p>",
	createNoteBtn: "Create a private note",
};
